import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';

const Wrapper = styled.div`
  background-color: var(--c-shark);
  font-size: var(--fs-m);
  ${legacyType('m', 'body')};
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  & p {
    margin-bottom: 32px;
  }

  & [class^='Button'],
  & [class^='btn'] {
    font-size: var(--fs-focus);
    font-weight: 400;
    padding: 1rem;
    line-height: 1;
    min-width: 9rem;
    border-radius: 5px;

    ${media.mediumLarge`
      min-width: 12rem;
    `}
  }

  & [class^='Button'] span,
  & [class^='btn'] span {
    position: relative;
    top: 1px;
    left: 2px;
  }
`;

const MainWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

MainWrapper.propTypes = {
  children: PropTypes.node,
};

export default MainWrapper;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/wrapper/MainWrapper.js